import { createSlice } from '@reduxjs/toolkit';
import {
  getPaginatedEnrolments,
  getPaginatedPendingInvitations,
} from './asyncActions';
import { INITIAL_STATE } from './state';
import { AsyncState } from './types';

export const institutionAdminSettingsSlice = createSlice({
  name: 'institutionAdminSettings',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaginatedEnrolments.pending, (state) => {
        state.paginatedInstitutionEnrolments.asyncState = AsyncState.LOADING;
      })
      .addCase(getPaginatedEnrolments.fulfilled, (state, action) => {
        const { payload } = action;
        if (payload) {
          const {
            enrolments,
            total,
            hasNextPage,
            hasPrevPage,
            totalPages,
          } = payload;
          state.paginatedInstitutionEnrolments = {
            asyncState: AsyncState.SUCCESS,
            enrolments,
            total,
            hasNextPage,
            hasPrevPage,
            totalPages,
          };
        }
      })
      .addCase(getPaginatedEnrolments.rejected, (state) => {
        state.paginatedInstitutionEnrolments.asyncState = AsyncState.FAILED;
      })
      .addCase(getPaginatedPendingInvitations.pending, (state) => {
        state.paginatedPendingInvitations.asyncState = AsyncState.LOADING;
      })
      .addCase(getPaginatedPendingInvitations.fulfilled, (state, action) => {
        const { payload } = action;
        if (payload) {
          state.paginatedPendingInvitations = {
            asyncState: AsyncState.SUCCESS,
            ...payload,
          };
        }
      })
      .addCase(getPaginatedPendingInvitations.rejected, (state) => {
        state.paginatedPendingInvitations.asyncState = AsyncState.FAILED;
      });
  },
});

export const InstitutionAdminSettings = institutionAdminSettingsSlice.reducer;
